import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useAxios from "../../../../api/useAxios";
import ImageDropZone from "../../../common/ImageDropZone";

const BodyEditModal = ({ selectedItem, open, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    name: "",
    isUsed: false,
    canUpdate: false,
    photo: null,
  });
  const instance = useAxios();
  const updateBodyPart = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("name", payload.name);
    formData.append("isUsed", payload.isUsed);
    if (payload.canUpdate !== undefined) {
      formData.append("canUpdate", payload.canUpdate);
    }
    if (payload.photo && typeof payload.photo !== "string") {
      formData.append("photo", payload.photo);
    }

    try {
      const response = await instance.put(
        `/body-part/${selectedItem._id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      handleClose(response.data.data);
    } catch (error) {
      console.log(error);
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPayload(selectedItem);
  }, [selectedItem]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>
        {" "}
        <div className="modal-header bg-info">
          <h4 className="modal-title">Edit Body Part</h4>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </DialogTitle>
      <DialogContent className="px-5">
        <Stack>
          <Box>
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={payload.name}
              onChange={(e) =>
                setPayload((prev) => ({ ...prev, name: e.target.value }))
              }
              className="form-control border border-info"
            />
          </Box>
          <Box className="mt-2">
            <label htmlFor="isUsed">Active</label>
            <input
              type="checkbox"
              id="isUsed"
              checked={payload.isUsed}
              onChange={() =>
                setPayload((prev) => ({ ...prev, isUsed: !payload.isUsed }))
              }
              className="ml-2"
            />
          </Box>
          <Box className="mt-2">
            <label htmlFor="canUpdate">Can Update</label>
            <input
              type="checkbox"
              id="canUpdate"
              checked={payload.canUpdate || false}
              onChange={() =>
                setPayload((prev) => ({ ...prev, canUpdate: !payload.canUpdate }))
              }
              className="ml-2"
            />
          </Box>
          <Box className="mt-2">
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500, color: "text.secondary", display: 'block' }}>
              Photo
            </Typography>
            <ImageDropZone
              file={payload.photo}
              onFileSelect={(file) => setPayload((prev) => ({ ...prev, photo: file }))}
              onFileRemove={() => setPayload((prev) => ({ ...prev, photo: null }))}
              label="Photo"
            />
          </Box>
          <Box className="d-flex justify-content-center">
            <Button
              onClick={updateBodyPart}
              startIcon={loading && <CircularProgress size={20} />}
            >
              Save
            </Button>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default BodyEditModal;
